export function fmtTime12(hhmm) {
  if (!hhmm || !/^\d{2}:\d{2}$/.test(hhmm)) return hhmm;
  let [h, m] = hhmm.split(":").map(Number);
  if (h === 24) h = 0;
  const period = h >= 12 ? "PM" : "AM";
  const h12 = ((h + 11) % 12) + 1;
  return `${h12}:${m.toString().padStart(2, "0")} ${period}`;
}

export function fmtTimeShort(hhmm) {
  // 10:00 AM → 10 AM; 10:30 AM → 10:30 AM
  if (!hhmm || !/^\d{2}:\d{2}$/.test(hhmm)) return hhmm;
  let [h, m] = hhmm.split(":").map(Number);
  if (h === 24) h = 0;
  const period = h >= 12 ? "PM" : "AM";
  const h12 = ((h + 11) % 12) + 1;
  return m === 0 ? `${h12} ${period}` : `${h12}:${m.toString().padStart(2, "0")} ${period}`;
}
